import React, { useCallback, useMemo } from "../../__compat__/react/main.entry.mjs.mjs";
import { Text } from "../Text/index.mjs.mjs";
import { Table, TableBody, TableCell, TableHeader, TableRow, TableColumnHeadingCell, TableRowHeadingCell, } from "../Table/index.mjs.mjs";
export const TableRenderer = React.forwardRef(({ caption, fixedLayout, columnHeadings, rowHeadings, contents, displayMode = 'auto', }, ref) => {
    const renderColumnHeadingCell = useCallback((heading, index) => {
        if (Array.isArray(heading)) {
            const [content, headingProps] = heading;
            return (React.createElement(TableColumnHeadingCell, { key: index, ...headingProps }, content));
        }
        return (React.createElement(TableColumnHeadingCell, { key: index }, heading));
    }, []);
    const renderColumnHeadings = useMemo(() => columnHeadings && (React.createElement(TableHeader, null,
        React.createElement(TableRow, null, columnHeadings.map(renderColumnHeadingCell)))), [columnHeadings, renderColumnHeadingCell]);
    const renderRowHeadingCell = useCallback((heading, index) => {
        if (Array.isArray(heading)) {
            const [content, headingProps] = heading;
            return (React.createElement(TableRowHeadingCell, { key: index, ...headingProps }, content));
        }
        return React.createElement(TableRowHeadingCell, { key: index }, heading);
    }, []);
    const wrapWithTextIfNeeded = (content) => {
        if (typeof content === 'string' || typeof content === 'number') {
            return (React.createElement(Text, { as: "span", variant: "copy1" }, content));
        }
        return content;
    };
    const renderCell = useCallback((cell, columnHeadings, index) => {
        const columnHeading = columnHeadings === null || columnHeadings === void 0 ? void 0 : columnHeadings[index];
        let content, props;
        if (Array.isArray(cell)) {
            content = wrapWithTextIfNeeded(cell[0]);
            props = cell[1];
        }
        else {
            content = wrapWithTextIfNeeded(cell);
        }
        return (React.createElement(TableCell, { key: index, columnHeading: columnHeading, ...props }, content));
    }, []);
    const renderBody = useMemo(() => contents.map((row, i) => (React.createElement(TableRow, { key: i },
        rowHeadings && renderRowHeadingCell(rowHeadings[i], i),
        row.map((cell, j) => renderCell(cell, columnHeadings, j))))), [rowHeadings, columnHeadings, renderCell, renderRowHeadingCell, contents]);
    return (React.createElement(Table, { caption: caption, fixedLayout: fixedLayout, displayMode: displayMode, ref: ref },
        renderColumnHeadings,
        React.createElement(TableBody, null, renderBody)));
});
TableRenderer.displayName = 'TableRenderer';
//# sourceMappingURL=TableRenderer.mjs.mjs.map